module.exports = __webpack_public_path__ + "static/media/CircularStd-Black.b5fa1b55.woff";